import {
  JsonFormat,
  objectJsonFormat,
  stringJsonFormat,
} from "@redotech/json/format";
import { useHandler } from "@redotech/react-util/hook";
import { jsonStore, localStore } from "@redotech/web-util/storage";
import { ReactNode, createContext, memo, useContext, useState } from "react";
import { AuthContext } from "./auth";

export interface User {
  name: { first: string; last: string };
}

export const userJsonFormat: JsonFormat<User> = objectJsonFormat(
  {
    name: objectJsonFormat(
      { first: stringJsonFormat, last: stringJsonFormat },
      {},
    ),
  },
  {},
);

export const UserContext = createContext<User | undefined>(undefined);

export interface SetUser {
  (user: User | undefined): void;
}

export const SetUserContext = createContext<SetUser | undefined>(undefined);

const userStore = jsonStore(localStore("redo.user"), userJsonFormat);

export const UserProvider = memo(function UserProvider({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const auth = useContext(AuthContext);
  const [user, setUser] = useState<User | undefined>(() => userStore.get());
  const setUser_ = useHandler<SetUser>((user) => {
    if (user === undefined) {
      userStore.set(undefined);
    } else {
      userStore.set(user);
    }
    setUser(user);
  });

  return (
    <UserContext.Provider value={auth && user}>
      <SetUserContext.Provider value={setUser_}>
        {children}
      </SetUserContext.Provider>
    </UserContext.Provider>
  );
});
